import axios from 'axios'
import Cookies from 'js-cookie';
import config from './config';
const loginData = (!Cookies.get('loginSuccessMember')) ? [] : JSON.parse(Cookies.get('loginSuccessMember'));

const serverPath = config.apiUrl;
export const request = (path, data, method) => {
    var options = {
        method: method,
        url: `${serverPath}/${path}`,
        headers: {
            'Content-Type': 'application/json'
        },
        dataType: 'json'
    };
    if (loginData) {
        options.headers['Authorization'] = loginData ?.authToken
    }
    if (method === 'GET') {
        options['params'] = data
    } else {
        options['data'] = data
    }

    let res = axios(options)
    res.then(res1 => {})
    return res
}

export const requestFormData = (path, data, method) => {
    var form_data = new FormData();
    for (var key in data) {


        if (key == "bundles_file_url") {
            data[key].forEach((file) => {
                form_data.append('bundles_file_url', file);
            });
        } else {
            form_data.append(key, data[key]);
        }


    }
    var options = {
        method: method,
        url: `${serverPath}/${path}`,
        data: form_data,
        headers: { authorization: loginData ?.authToken },
    };
    let res = axios(options);
    res.then(res1 => {})
    return res
}
export const requestadFormData = (path, data, method) => {
    var form_data = new FormData();
    
    for (var key in data) {
		if(key !== 'images'){
			form_data.append(key, data[key]);
		}
    }
    if (data.images && data.images.length > 0) {
    data.images.forEach((image) => {
            form_data.append('images', image);
        });  
	}    
    var options = {
        method: method,
        url: `${serverPath}/${path}`,
        data : form_data,
        headers: { authorization: loginData?.authToken },
    };
    let res = axios(options);
    res.then(res1 => { })
    return res
}

export const postRequest = async(path, data) => await request(path, data, 'POST')
export const getRequest = async(path, data) => await request(path, data, 'GET')
export const putRequest = async(path, data) => await request(path, data, 'PUT')
export const deleteRequest = async(path, data) => await request(path, data, 'DELETE')
export const postRequestFormData = async(path, data) => await requestFormData(path, data, 'POST')
export const postRequestadFormData = async (path, data) => await requestadFormData(path, data, 'POST')
